<template>
  <component
    :is="comp"
    is-lpu-page
    :soft-version="softVersion"
    class="soft-version-icon"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'

defineProps<{
  softVersion: string
}>()

const SoftVersionIconMobile = () => import(/* webpackMode: 'eager' */ 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/SoftVersionIcon/components/mobile/SoftVersionIcon.vue')
const SoftVersionIconDesktop = () => import(/* webpackMode: 'eager' */ 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/SoftVersionIcon/components/desktop/SoftVersionIcon.vue')

const isMobile = useIsMobile()

const comp = computed(() => {
  if (typeof window === 'undefined') {
    return 'div'
  }

  return isMobile.value ? SoftVersionIconMobile : SoftVersionIconDesktop
})
</script>

<style lang="scss" scoped>
.soft-version-icon {
  display: inline;
  vertical-align: middle;
  position: relative;
  font-size: 0;
  line-height: 33px;

  // Заглушка на время рендера компонента изображения, благодаря которой размер не "прыгает"
  &::after {
    content: '';
    display: inline-block;
    width: 28px;
    height: 33px;
    vertical-align: top;
  }
}
</style>
